<small class="form-text text-danger"><img src="../assets/img/red_error_msg.svg">{{ message }}<slot></slot></small>